import Vue from "vue";
import Router from "vue-router";
import { i18n, loadLanguageAsync } from "./i18n";

Vue.use(Router);

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

const routes = [
  {
    path: "/",
    component: () => import("./layout/MainLayout.vue"),
    redirect: "/home",
    children: [
      {
        path: "/home",
        name: "home",
        meta: { title: "nav.home" },
        component: () => import("./views/Home/Home.vue"),
      },
      {
        path: "/search",
        name: "search",
        meta: { title: "nav.search" },
        component: () => import("./views/Home/Search.vue"),
      },
      {
        path: "/research-focus",
        name: "researchFocus",
        meta: { title: "nav.researchFocus" },
        component: () => import("./views/Research/Focus.vue"),
      },
      {
        path: "/index-tool",
        name: "indexTool",
        meta: { title: "nav.indexTool" },
        component: () => import("./views/Research/IndexTool.vue"),
      },
      {
        path: "/index-detail/:code",
        name: "indexDetail",
        meta: { title: "nav.indexDetail" },
        component: () => import("./views/Research/IndexDetail.vue"),
      },
      {
        path: "/annual-forum",
        name: "annualForum",
        meta: { title: "nav.annualForum" },
        component: () => import("./views/Events/Annual.vue"),
      },
      {
        path: "/themed-events",
        name: "themedEvent",
        meta: { title: "nav.themedEvent" },
        component: () => import("./views/Events/Thematic.vue"),
      },
      {
        path: "/climate-philanthropy-and-business-dialogue-shanghai",
        name: "bussinessDialogue",
        meta: { title: "nav.bussinessDialogue", forceLang: "en" },
        component: () => import("./views/Events/BusinessDialogue.vue"),
      },
      {
        path: "/expert-opinion",
        name: "expertOpinion",
        meta: { title: "nav.expertOpinion" },
        component: () => import("./views/News/Opinion.vue"),
      },
      {
        path: "/news-trends",
        name: "newsTrends",
        meta: { title: "nav.newsTrends" },
        component: () => import("./views/News/Trends.vue"),
      },
      {
        path: "/news-detail/:id",
        meta: { title: "nav.newsDetail" },
        component: () => import("./views/News/NewsDetail.vue"),
      },
      {
        path: "/forum-journal",
        name: "forumJournal",
        meta: { title: "nav.forumJournal" },
        component: () => import("./views/News/Journal.vue"),
      },
      {
        path: "/expert-committee",
        name: "expertCommittee",
        meta: { title: "nav.expertCommittee" },
        component: () => import("./views/About/Committee.vue"),
      },
      {
        path: "/secretariat-introduction",
        name: "secretariatIntroduction",
        meta: { title: "nav.secretariatIntroduction" },
        component: () => import("./views/About/Secretariat.vue"),
      },
      {
        path: "/contact-information",
        name: "contactInformation",
        meta: { title: "nav.contactInformation" },
        component: () => import("./views/About/Contact.vue"),
      },
      {
        path: "/alliance",
        name: "alliance",
        meta: { title: "nav.alliance" },
        component: () => import("./views/About/Alliance.vue"),
      },
    ],
  },
  {
    path: "/mobile/green-finance-award",
    name: "mobile-gfa",
    component: () => import("./views/Activities/GreenFinanceAward"),
    meta: {
      title: "GF60绿色金融奖评选说明",
      enTit: "GreenFinanceAward",
    },
  },
  {
    path: "/mobile/green-finance-award-2023",
    name: "mobile-gfa2023",
    component: () => import("./views/Activities/GreenFinanceAward2023"),
    meta: {
      title: "GF60绿色金融奖评选说明",
      enTit: "GreenFinanceAward",
    },
  },
  {
    path: "/mobile/green-finance-award-2024",
    name: "mobile-gfa2024",
    component: () => import("./views/Activities/GreenFinanceAward2024"),
    meta: {
      title: "GF60绿色金融案例评选说明",
      enTit: "GreenFinanceAward",
    },
  },
  {
    path: "/mobile/green-finance-award-2025",
    name: "mobile-gfa2024",
    component: () => import("./views/Activities/GreenFinanceAward2025"),
    meta: {
      title: "2025 GF60可持续发展评选",
      enTit: "GreenFinanceAward",
    },
  },  {
    path: "/mobile/green-finance-award-2026",
    name: "mobile-gfa2026",
    component: () => import("./views/Activities/GreenFinanceAward2026"),
    meta: {
      title: "2026 GF60可持续发展评选",
      enTit: "GreenFinanceAward",
    },
  },
  {
    path: "/mobile/summit-meeting",
    name: "mobile-sm",
    component: () =>
      import("./views/Activities/SummitMeeting/SummitMeeting.vue"),
    meta: {
      title: "专题｜2022绿色金融国际峰会",
      enTit: "Summit Meeting",
    },
  },
  {
    path: "/mobile/summit-meeting-imgs",
    name: "mobile-sm-img",
    component: () => import("./views/Activities/SummitMeeting/SMImageList"),
    meta: {
      title: "精彩图集",
      enTit: "Summit Meeting Images",
    },
  },
  {
    path: "/mobile/summit-meeting-awards",
    name: "mobile-sm-img",
    component: () => import("./views/Activities/SummitMeeting/SMAwards"),
    meta: {
      title: "绿金评选",
      enTit: "Summit Meeting Awards",
    },
  },
  {
    path: "/us/pc/home",
    redirect: "/home",
  },
  {
    path: "/us/mobile/home",
    redirect: "/home",
  },
  {
    path: "/pc/home",
    redirect: "/home",
  },
  {
    path: "/mobile/home",
    redirect: "/home",
  },
  {
    path: "/pc/detail/:id",
    redirect: "/news-detail/:id",
  },
  {
    path: "/mobile/detail/:id",
    redirect: "/news-detail/:id",
  },
  {
    path: "/call-to-action-small-funds-great-impact",
    name: "callToActionPDF",
    meta: { title: "Call to Action: Small Funds, Great Impact" },
    component: () => import("./views/CallToActionPDF.vue"),
  },
  {
    path: "/*",
    redirect: "/home",
  },
];

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  const forcedLang = to.meta && to.meta.forceLang ? to.meta.forceLang : null;
  const storedLang = localStorage.getItem("lang");
  const targetLang = forcedLang || storedLang || "en";

  const setTitle = () => {
    if (to.meta.title) {
      const base = i18n.t(to.meta.title);
      // 如果路径包含 green-finance-award，则不拼接论坛后缀
      const shouldSkipSuffix =
        to.path && to.path.includes("green-finance-award");
      if (shouldSkipSuffix) {
        document.title = base;
      } else {
        document.title = `${base}${
          i18n.locale === "en"
            ? "-Green Finance Forum of 60"
            : "-绿色金融60人论坛"
        }`;
      }
    }
  };

  if (i18n.locale !== targetLang) {
    loadLanguageAsync(targetLang).then(() => {
      setTitle();
      next();
    });
  } else {
    setTitle();
    next();
  }
});

export default router;
